import { useRef, useState } from 'react';
import '../common.scss';
import './styles.scss';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import MainScreen from '../../components/MainScreen';
import PreFooter from '../../components/PreFooter';
import Back from './bg.jpg';
import Popup from '../../components/Popup';
import cn from 'classnames';
import { isValidPhoneNumber } from 'libphonenumber-js';

const FORM_URL =
  'https://script.google.com/macros/s/AKfycbym1Ag0setc6Cn-bzs-MRzW3AjEuzUG9Xtigcdp5p03TFdn58zv_X5dFpF_M5XJtnRlDg/exec';
const token = '2XjFwIxoa4t7jql0bd7wo91bd0';

const MainPage = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [data, setData] = useState({});
  const [isSending, setSending] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const formRef = useRef(null);
  const [isCheckboxActive, setCheckboxActive] = useState(false);

  const scrollToForm = () => {
    formRef.current?.scrollIntoView({
      behavior: 'smooth',
      block: 'start',
    });
  };

  const handleChangeField = (name, value) => {
    const newData = { ...data };
    newData[name] = value;
    setData(newData);
  };

  const handleSubmit = async e => {
    e.preventDefault();
    if (
      (isCheckboxActive && !data.user_phone_number?.trim()) ||
      (!isCheckboxActive && (data.candidate_phone_number?.trim() || data.user_phone_number?.trim())) ||
      !isValidPhone(data.candidate_phone_number) ||
      !isValidPhone(data.user_phone_number)
    )
      return;

    setSending(true);

    try {
      const candidate_first_name = document.querySelector('#candidate_first_name')?.value || '';
      const candidate_last_name = document.querySelector('#candidate_last_name')?.value || '';
      const candidate_phone_number = document.querySelector('#candidate_phone_number')?.value || '';
      const candidate_email_address = document.querySelector('#candidate_email_address')?.value || '';
      const type_candidate = document.querySelector('#type_candidate')?.value || '';
      const interest = document.querySelector('#interest')?.value || '';
      const user_first_name = document.querySelector('#user_first_name')?.value || '';
      const user_last_name = document.querySelector('#user_last_name')?.value || '';
      const user_phone_number = document.querySelector('#user_phone_number')?.value || '';
      const user_email_address = document.querySelector('#user_email_address')?.value || '';
      const notes = document.querySelector('#notes')?.value || '';

      const values = {
        token,
        candidate_first_name,
        candidate_last_name,
        candidate_phone_number,
        candidate_email_address,
        type_candidate,
        interest,
        user_first_name,
        user_last_name,
        user_phone_number,
        user_email_address,
        notes,
      };

      await fetch(`${FORM_URL}`, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      });

      setIsSuccess(true);
    } catch (err) {
      console.error(err);
    } finally {
      setSending(false);
    }
  };

  const isValidEmail = email => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  };

  const isValidPhone = phone => !phone?.trim() || isValidPhoneNumber(phone.trim(), 'US');

  return (
    <div className='page'>
      <Header />
      <MainScreen
        title='Candidate Referral Program'
        text='Refer Candidates to American Consultants and Earn Up to $500 Per Referral!'
        mainButtonText='Submit a Referral'
        onMainClick={scrollToForm}
        background={Back}
      />

      <div className='descriptionBlock'>
        <span className='blockTitle'>Earn Up to $500 Per Referral</span>
        <span className='blockText'>
          Do you know a talented healthcare professional who is looking for their next job opportunity? Refer them to us, and you
          could earn up to $500 once they're hired and complete their hours!
        </span>
      </div>

      <div className='mainPointsSection'>
        <span className='blockTitle'>Referral Bonus Amount by Position</span>
        <span className='blockText'>Earn generous rewards based on the position of your referral.</span>

        <div className='points'>
          <div className='pointItem'>
            <span className='pointItemCount'>$250</span>
            <span className='pointItemTitle'>LPN / LVN / CNA</span>
            <span className='pointItemText'>Licensed Practical & Certified Nursing Assistants</span>
            <span className='pointItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='45' height='48' viewBox='0 0 45 48' fill='none'>
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M32.9111 15.754C34.0524 16.2894 35.3277 16.6584 36.7098 16.6584C38.0947 16.6584 39.3733 16.2894 40.5146 15.754C42.1741 15.754 43.4677 17.0247 43.4717 18.609L43.4643 26.2052C43.4643 27.2747 43.2884 27.9398 42.9745 28.4479C42.6606 28.9559 42.1741 29.3536 41.413 29.7814C41.181 29.9144 41.0369 30.1537 41.0261 30.4185L40.5606 42.8336C40.5532 43.004 40.5011 43.0842 40.2684 43.2193C40.0322 43.3556 39.6236 43.4566 39.194 43.4566C38.7638 43.4566 38.3166 43.3596 37.9952 43.1992C37.7172 43.0602 37.5589 42.8964 37.4777 42.7226V32.8723C37.4851 32.4505 37.1469 32.107 36.7233 32.0996C36.2937 32.0922 35.9413 32.4439 35.9487 32.8723V42.7112C35.8709 42.8924 35.716 43.0562 35.4312 43.1985C35.1098 43.359 34.6593 43.4559 34.2297 43.4559C33.7994 43.4559 33.3908 43.3549 33.1547 43.2186C32.9219 43.0829 32.8732 43.0067 32.8698 42.8329L32.401 30.4178C32.3909 30.1531 32.2461 29.9131 32.014 29.7807C31.8057 29.6658 31.6189 29.5475 31.4464 29.4332C31.809 28.6317 31.9815 27.6852 31.9815 26.5428L31.9849 17.8108C31.9849 17.1845 31.8584 16.5856 31.6365 16.0354C32.0188 15.8583 32.449 15.754 32.9111 15.754ZM4.48268 15.754C5.62466 16.2894 6.90736 16.6584 8.28816 16.6584C9.67301 16.6584 10.9483 16.2894 12.0902 15.754C12.551 15.754 12.9812 15.8583 13.3655 16.0354C13.1436 16.5889 13.0164 17.1845 13.0164 17.8108L13.0239 26.5428C13.0239 27.6852 13.1923 28.6317 13.5563 29.4332C13.3831 29.5475 13.1964 29.6624 12.9853 29.7807C12.756 29.9138 12.6085 30.1531 12.5976 30.4178L12.1329 42.8329C12.1254 43.0067 12.0794 43.0836 11.8433 43.2186C11.6106 43.3549 11.202 43.4559 10.7724 43.4559C10.3421 43.4559 9.89085 43.359 9.57085 43.1985C9.28468 43.0562 9.12705 42.8917 9.05196 42.7112V32.8723C9.05534 32.4439 8.7076 32.0922 8.27327 32.0996C7.85044 32.107 7.51218 32.4505 7.51894 32.8723V42.7219C7.44114 42.8957 7.28351 43.0595 7.00478 43.1985C6.68343 43.359 6.23624 43.4559 5.80665 43.4559C5.37299 43.4559 4.96775 43.3549 4.73164 43.2186C4.49959 43.0829 4.44683 43.0027 4.43938 42.8329L3.97461 30.4178C3.96378 30.1531 3.81562 29.9131 3.58696 29.7807C2.8218 29.3529 2.33944 28.9552 2.02553 28.4472C1.71229 27.9392 1.53301 27.2741 1.53301 26.2045L1.52963 18.6083C1.53369 17.0247 2.82654 15.754 4.48268 15.754ZM17.9355 14.4211C19.6511 15.2393 21.2017 15.4552 22.5027 15.4552C23.8023 15.4552 25.3495 15.2393 27.0652 14.4211C28.9723 14.5013 30.4479 15.9773 30.4479 17.8115V26.5434C30.4479 27.7834 30.2368 28.5775 29.8559 29.1825C29.4791 29.7888 28.8973 30.258 28.0056 30.7567C27.7729 30.885 27.6247 31.1257 27.6152 31.3904L27.076 45.6578C27.0652 45.9011 26.9779 46.0341 26.6809 46.2005C26.3853 46.371 25.8914 46.486 25.3773 46.486C24.8631 46.486 24.3239 46.371 23.9329 46.1765C23.5804 46.002 23.3693 45.7894 23.2699 45.5501V34.2059C23.2773 33.8443 23.0236 33.4499 22.502 33.4499C21.977 33.4499 21.726 33.8436 21.7301 34.2059V45.5488C21.632 45.7888 21.4196 46.0007 21.0678 46.1751C20.6761 46.3697 20.1403 46.4846 19.6227 46.4846C19.1086 46.4846 18.6187 46.3697 18.3231 46.1992C18.0234 46.0328 17.9355 45.8997 17.9246 45.6564L17.3861 31.389C17.3787 31.1243 17.2312 30.8837 16.9985 30.7553C16.1075 30.2574 15.5216 29.7874 15.1448 29.1812C14.7679 28.5762 14.5569 27.7821 14.5569 26.5421V17.8115C14.5562 15.9773 16.0297 14.5013 17.9355 14.4211ZM18.0978 12.8997C16.5087 12.8997 15.0852 13.6103 14.1516 14.7239C13.5346 14.4104 12.8338 14.2326 12.0902 14.2326C11.9664 14.2326 11.8433 14.26 11.7303 14.3189C10.7507 14.8316 9.55665 15.137 8.28816 15.137C7.01966 15.137 5.81815 14.8316 4.83853 14.3189C4.72961 14.26 4.60581 14.2326 4.482 14.2326C2.02282 14.2326 0 16.1892 0 18.6123L0.00338272 26.2052C0.00338272 27.4485 0.225285 28.4405 0.722533 29.2453C1.13116 29.9064 1.78333 30.4325 2.45986 30.8603L2.91449 42.889C2.94222 43.6197 3.41782 44.2186 3.96784 44.5394C4.52057 44.8556 5.15853 44.9779 5.80732 44.9779C6.81129 44.9779 7.73137 44.6578 8.28816 44.1564C8.93695 44.7279 9.95445 44.9746 10.7724 44.9779C11.4171 44.9813 12.0551 44.8556 12.6078 44.5394C13.1571 44.2186 13.6368 43.6197 13.6611 42.889L14.1083 30.8496C14.203 30.7908 14.2984 30.732 14.3932 30.6725C14.816 31.1217 15.3241 31.518 15.8626 31.8523L16.3909 45.7159C16.4227 46.5134 16.941 47.1604 17.5573 47.5127C18.1709 47.8636 18.8934 48 19.622 48C20.3554 48 21.0989 47.8563 21.7572 47.5328C22.0893 47.3697 22.2896 47.1952 22.5013 47.0214C22.709 47.1952 22.9134 47.3697 23.2449 47.5328C23.8997 47.8563 24.6439 48 25.3766 48C26.11 48 26.8291 47.8636 27.4447 47.5127C28.0584 47.1604 28.5759 46.5134 28.6077 45.7159L29.1361 31.8523C29.6753 31.518 30.1827 31.125 30.6055 30.6725C30.7002 30.732 30.7922 30.7908 30.8876 30.8496L31.3348 42.889C31.3625 43.6197 31.8381 44.2186 32.3909 44.5394C32.9449 44.8556 33.5822 44.9813 34.2276 44.9779C35.0449 44.9746 36.0597 44.7273 36.7085 44.1564C37.2686 44.6584 38.188 44.9779 39.1927 44.9779C39.8367 44.9779 40.4781 44.8556 41.0281 44.5394C41.5808 44.2186 42.0564 43.6197 42.0855 42.889L42.5368 30.8603C43.216 30.4325 43.8648 29.9064 44.2734 29.2453C44.774 28.4405 44.9926 27.4485 44.9926 26.2052L45 18.6123C45 16.1892 42.9778 14.2326 40.5139 14.2326C40.3915 14.2326 40.2711 14.26 40.1588 14.3189C39.1791 14.8316 37.9776 15.137 36.7091 15.137C35.4433 15.137 34.2459 14.8316 33.2663 14.3189C33.1574 14.26 33.0336 14.2326 32.9111 14.2326C32.1669 14.2326 31.466 14.4098 30.8497 14.7239C29.9114 13.6096 28.492 12.8997 26.9062 12.8997C26.7797 12.8964 26.6566 12.9271 26.547 12.9826C25.3915 13.5816 23.989 13.9405 22.502 13.9405C21.011 13.9405 19.6092 13.5816 18.4564 12.9826C18.3441 12.9271 18.2216 12.8957 18.0978 12.8997Z'
                  fill='#F39B38'
                />
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M36.7057 4.53342C38.8226 4.53342 40.4267 5.99265 40.4267 7.72594V9.34425C40.4267 11.0789 38.8226 12.5401 36.7057 12.5401C34.5875 12.5401 32.9848 11.0782 32.9848 9.34425V7.72594C32.9848 5.99198 34.5882 4.53342 36.7057 4.53342ZM36.7057 3.01537C33.8555 3.01537 31.4525 5.07955 31.4525 7.72594V9.34425C31.4525 11.9906 33.8555 14.0555 36.7057 14.0555C39.56 14.0555 41.959 11.9906 41.959 9.34425V7.72594C41.9597 5.07955 39.56 3.01537 36.7057 3.01537Z'
                  fill='#F39B38'
                />
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M8.29222 4.53676C10.4165 4.53676 12.0165 5.99599 12.0165 7.72594V9.34826C12.0165 11.0755 10.4165 12.5374 8.29222 12.5374C6.17062 12.5374 4.57469 11.0755 4.57469 9.34826V7.72594C4.57469 5.99599 6.17062 4.53676 8.29222 4.53676ZM8.29222 3.01203C5.44471 3.01203 3.04167 5.07286 3.04167 7.72594V9.34826C3.04167 12.0013 5.44471 14.0622 8.29222 14.0622C11.1424 14.0622 13.5455 12.0013 13.5455 9.34826V7.72594C13.5455 5.07219 11.1424 3.01203 8.29222 3.01203Z'
                  fill='#F39B38'
                />
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M22.5088 1.51471C25.0255 1.51471 26.9387 3.24532 26.9387 5.30281V7.16177C26.9387 9.21992 25.0255 10.9499 22.5088 10.9499C19.9928 10.9499 18.0762 9.21992 18.0762 7.16177V5.30281C18.0762 3.24532 19.9935 1.51471 22.5088 1.51471ZM22.5088 0C19.2675 0 16.5438 2.32553 16.5438 5.30214V7.1611C16.5438 10.1417 19.2682 12.4632 22.5088 12.4632C25.7541 12.4632 28.4751 10.1417 28.4751 7.1611V5.30214C28.4751 2.32553 25.7541 0 22.5088 0Z'
                  fill='#F39B38'
                />
              </svg>
            </span>
          </div>

          <div className='pointItem'>
            <span className='pointItemCount'>$500</span>
            <span className='pointItemTitle'>RNs & Allied Health</span>
            <span className='pointItemText'>Registered Nurses & Allied Health Professionals</span>
            <span className='pointItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='48' height='48' viewBox='0 0 48 48' fill='none'>
                <path
                  d='M42.5014 36.3027C39.9989 34.4674 34.96 32.4986 33.235 31.8521C33.2252 31.6851 33.1905 31.5185 33.1306 31.3571C32.9713 30.9282 32.654 30.5881 32.2371 30.3996L29.9993 29.3874C29.7267 29.2642 29.4312 29.218 29.1409 29.245V28.6227C31.4187 27.2097 33.0759 24.8881 33.6026 22.1677C35.5758 21.8865 37.0981 20.1864 37.0981 18.1367C37.0981 17.1588 36.7548 16.234 36.1266 15.4981V8.49245C36.1266 3.8097 32.3169 0 27.6342 0H21.0663C18.0358 0 15.53 2.28857 15.1861 5.22813C13.305 5.56678 11.8734 7.2158 11.8734 9.1929V15.4982C11.2453 16.234 10.9019 17.1587 10.9019 18.1367C10.9019 20.1864 12.4242 21.8865 14.3974 22.1677C14.9241 24.888 16.5813 27.2097 18.8591 28.6227V29.2451C18.5688 29.218 18.2733 29.2643 18.0007 29.3874L15.7629 30.3996C15.3459 30.5882 15.0286 30.9283 14.8693 31.3573C14.8094 31.5186 14.7747 31.6851 14.765 31.8521C13.0399 32.4986 8.00103 34.4675 5.49849 36.3027C2.00414 38.8652 0 42.8532 0 47.2441C0 47.6616 0.338414 48 0.755906 48C1.1734 48 1.51181 47.6616 1.51181 47.2441C1.51181 41.8991 4.56971 38.8585 6.39253 37.5218C7.56611 36.6612 9.40214 35.7443 11.1464 34.9668V37.9349C9.31308 38.2891 7.9239 39.9052 7.9239 41.8405V46.1048C7.9239 47.1498 8.77407 48 9.81907 48C10.2366 48 10.575 47.6616 10.575 47.2441C10.575 46.8266 10.2366 46.4882 9.81907 46.4882C9.60767 46.4882 9.43572 46.3162 9.43572 46.1048V41.8405C9.43572 40.4803 10.5423 39.3738 11.9024 39.3738C13.2625 39.3738 14.369 40.4803 14.369 41.8405V46.1048C14.369 46.3162 14.197 46.4882 13.9856 46.4882C13.5681 46.4882 13.2297 46.8266 13.2297 47.2441C13.2297 47.6616 13.5681 48 13.9856 48C15.0306 48 15.8808 47.1498 15.8808 46.1048V41.8405C15.8808 39.9052 14.4916 38.2891 12.6582 37.9349V34.3153C13.7134 33.875 14.6349 33.5182 15.2155 33.2989L15.605 34.1372L14.3533 35.1885C14.0392 35.4523 13.9927 35.9184 14.2486 36.2389L23.4087 47.715C23.4099 47.7165 23.4113 47.7178 23.4125 47.7192C23.8042 48.0934 24.1959 48.0933 24.5876 47.7192C24.5886 47.718 24.5898 47.7169 24.5908 47.7157L33.1764 36.9592C33.7568 36.2323 33.6534 35.1941 32.941 34.5958L32.395 34.1372L32.7845 33.2989C33.3651 33.5182 34.2865 33.875 35.3417 34.3153V41.8945C33.9968 42.2328 32.9981 43.452 32.9981 44.9004C32.9981 46.6095 34.3885 48 36.0976 48C37.8067 48 39.1972 46.6095 39.1972 44.9004C39.1972 43.452 38.1984 42.2328 36.8535 41.8945V34.9668C38.5978 35.7443 40.4339 36.6612 41.6075 37.5218C43.4302 38.8585 46.4882 41.8991 46.4882 47.2441C46.4882 47.6616 46.8266 48 47.2441 48C47.6615 48 48 47.6616 48 47.2441C48 42.8532 45.9958 38.8652 42.5014 36.3027Z'
                  fill='#F39B38'
                />
              </svg>
            </span>
          </div>

          <div className='pointItem'>
            <span className='pointItemCount'>$500</span>
            <span className='pointItemTitle'>Healthcare Executives</span>
            <span className='pointItemText'>Healthcare Executives & Managers</span>
            <span className='pointItemIcon'>
              <svg xmlns='http://www.w3.org/2000/svg' width='57' height='48' viewBox='0 0 57 48' fill='none'>
                <path
                  fillRule='evenodd'
                  clipRule='evenodd'
                  d='M20.1216 4.76146L19.7174 1.33522H16.5773L16.1707 4.76146C16.1378 5.0597 15.9051 5.29923 15.609 5.3415C13.9121 5.67496 12.2998 6.34426 10.8661 7.31174C10.6193 7.47847 10.2926 7.46203 10.0646 7.26947L7.3688 5.14184L5.15245 7.35634L7.29125 10.0663C7.46987 10.2941 7.48162 10.6111 7.31945 10.8507C6.34641 12.2902 5.67421 13.9106 5.34522 15.6132C5.28881 15.8997 5.05613 16.1181 4.76704 16.1509L1.33794 16.5549V19.697L4.76704 20.1032V20.1009C5.06553 20.1361 5.30526 20.3662 5.34992 20.6645C5.68131 22.36 6.35117 23.971 7.31945 25.4011C7.48632 25.6477 7.46988 25.9741 7.2795 26.2019L5.15244 28.8955L7.36879 31.1146L10.081 28.9776C10.309 28.7992 10.6263 28.7874 10.8661 28.9495C12.3068 29.9217 13.9285 30.5933 15.6348 30.9244C15.9192 30.9785 16.1378 31.2109 16.1707 31.4998L16.5773 34.926H19.7174L20.1216 31.4998C20.1569 31.2016 20.3872 30.962 20.6857 30.9174C22.3826 30.5863 23.9949 29.917 25.4263 28.9495C25.6731 28.7828 25.9997 28.7992 26.2277 28.9894L28.9235 31.1147L31.1446 28.8955L29.0081 26.1879C28.8272 25.9601 28.8154 25.6454 28.9776 25.4035C29.9506 23.964 30.6228 22.346 30.9542 20.6411C31.0083 20.3546 31.2433 20.1385 31.53 20.1033L34.9615 19.697V16.562L31.5324 16.1581C31.2339 16.1228 30.9942 15.8904 30.9495 15.5945C30.6181 13.899 29.9483 12.288 28.98 10.8555C28.8131 10.6089 28.8296 10.2825 29.0199 10.0547L31.147 7.36115L28.9259 5.14665L26.2137 7.28366C25.974 7.47153 25.6379 7.47388 25.3958 7.28836C23.9621 6.3302 22.3545 5.668 20.6622 5.33687C20.3755 5.28286 20.1593 5.05037 20.124 4.76153L20.1216 4.76146ZM21.5247 15.1131C21.788 14.8642 22.2016 14.8689 22.4578 15.1249C22.714 15.3809 22.7187 15.7942 22.4696 16.0572L17.4658 21.0568C17.078 21.4443 16.4481 21.4443 16.058 21.0568L13.8228 18.8236H13.8252C13.5643 18.5629 13.5643 18.1402 13.8252 17.8795C14.0861 17.6189 14.5091 17.6189 14.77 17.8795L16.7631 19.8709L21.5247 15.1131ZM18.1473 7.52808C21.4448 7.52808 24.5564 9.06156 26.5636 11.6752C28.5731 14.2913 29.25 17.6894 28.3945 20.8739C27.5414 24.0559 25.2545 26.6626 22.2087 27.9239C19.1603 29.185 15.6985 28.9595 12.8429 27.311C9.98728 25.6624 8.06004 22.781 7.62755 19.5143C7.19745 16.2477 8.31148 12.9645 10.6453 10.6349C12.6314 8.6435 15.3315 7.52573 18.1473 7.52808Z'
                  fill='#F39B38'
                />
              </svg>
            </span>
          </div>
        </div>
      </div>

      <div className='pointsSection'>
        <span className='blockTitle'>How to Qualify for a Referral Bonus</span>
        <span className='blockText'>Earning your bonus is straightforward! Just follow these steps.</span>

        <div className='points'>
          <div className='pointItem'>
            <span className='pointItemTitle'>Refer a&nbsp;Candidate</span>
            <span className='pointItemText'>
              Submit a referral using the form below. It only takes a few minutes to get started.
            </span>
            <span className='pointItemIcon'>1</span>
          </div>

          <div className='pointItem'>
            <span className='pointItemTitle'>Ensure Eligibility</span>
            <span className='pointItemText'>
              Your referral must meet the following criteria:
              <ul>
                <li> Be a new candidate who has never worked with AC.</li>
                <li>Be hired into a temporary or permanent position within 6 months of the date of the referral.</li>
              </ul>
            </span>
            <span className='pointItemIcon'>2</span>
          </div>

          <div className='pointItem'>
            <span className='pointItemTitle'>Complete the Required Hour</span>
            <span className='pointItemText'>
              For travel contract positions, the referred candidate must work 468 hours. For direct-hire roles, they must complete
              90 days of employment.
            </span>
            <span className='pointItemIcon'>3</span>
          </div>

          <div className='pointItem'>
            <span className='pointItemTitle'>Receive Your&nbsp;Bonus</span>
            <span className='pointItemText'>
              Once the requirements are met, your referral bonus will be paid to you. No limits — refer as many qualified
              candidates as you'd like!
            </span>
            <span className='pointItemIcon'>4</span>
          </div>
        </div>

        <div className='pointsDescriptionInfo'>
          <div className='pointsDescriptionInfoItem'>
            <span className='pointsDescriptionInfoTitle'>Who Can You Refer?</span>
            <span className='pointsDescriptionInfoText'>
              Nurses, therapists, or other healthcare professionals qualified for roles with AC clients.
            </span>
          </div>
          <div className='pointsDescriptionInfoItem'>
            <span className='pointsDescriptionInfoTitle'>How Many Bonuses Can You Earn?</span>
            <span className='pointsDescriptionInfoText'>
              Unlimited referrals and bonuses — earn as much as you want! There is no cap on the number of referrals you can
              submit.
            </span>
          </div>
        </div>
      </div>

      <div className='referralFormHolder' ref={formRef}>
        <span className='referralFormTitle'>Candidate Referral Program</span>
        <span className='referralFormText'>
          Refer Candidates to American Consultants and Earn Up to $500 per Referral! Fill out the form below to refer your friend
          or colleague and start earning rewards.
        </span>

        <div className='mainFormContacts'>
          <div className='mainFormOverlay'>
            {isSuccess && (
              <div className='mainFormSuccess'>
                <svg xmlns='http://www.w3.org/2000/svg' width='120' height='120' viewBox='0 0 120 120' fill='none'>
                  <path
                    d='M45 60L55 70L75 50M110 60C110 87.6142 87.6142 110 60 110C32.3858 110 10 87.6142 10 60C10 32.3858 32.3858 10 60 10C87.6142 10 110 32.3858 110 60Z'
                    stroke='#14A852'
                    stroke-width='5'
                    stroke-linecap='round'
                    stroke-linejoin='round'
                  />
                </svg>
                <span className='mainFormSuccessTitle'>Success!</span>
                <span className='mainFormSuccessText'>
                  We’ve received your request and will contact you within 1 business day.
                </span>
              </div>
            )}
            <span className='mainFormTitle'>Referral Form</span>

            <span className='referralFormSubtitle'>About Your Friend</span>
            <div className='mainFormFields'>
              <div className='mainFormField'>
                <label className='mainFormLabel'>
                  First Name <span className='mainFormRequiredMark'>*</span>
                </label>
                <input
                  className='mainFormInput'
                  value={data.candidate_first_name}
                  id='candidate_first_name'
                  onChange={e => handleChangeField('candidate_first_name', e.target.value)}
                />
              </div>
              <div className='mainFormField'>
                <label className='mainFormLabel'>
                  Last Name <span className='mainFormRequiredMark'>*</span>
                </label>
                <input
                  className='mainFormInput'
                  value={data.candidate_last_name}
                  id='candidate_last_name'
                  onChange={e => handleChangeField('candidate_last_name', e.target.value)}
                />
              </div>
              <div className='mainFormField'>
                <label className='mainFormLabel'>Phone Number</label>
                <input
                  className='mainFormInput'
                  value={data.candidate_phone_number}
                  id='candidate_phone_number'
                  onChange={e => handleChangeField('candidate_phone_number', e.target.value)}
                />
              </div>
              <div className='mainFormField'>
                <label className='mainFormLabel'>
                  Email Address <span className='mainFormRequiredMark'>*</span>
                </label>
                <input
                  className='mainFormInput'
                  value={data.candidate_email_address}
                  id='candidate_email_address'
                  onChange={e => handleChangeField('candidate_email_address', e.target.value)}
                />
              </div>
              <div className='mainFormField'>
                <label className='mainFormLabel'>Type of Candidate</label>
                <select
                  className='mainFormSelect'
                  name='type_candidate'
                  onChange={e => handleChangeField('type_candidate', e.target.value)}
                  id='type_candidate'
                >
                  <option value=''>Please choose an option</option>
                  <option value='RN'>RN</option>
                  <option value='LPN'>LPN</option>
                  <option value='allied_health'>Allied Health</option>
                  <option value='interim_leader'>Interim Leader</option>
                </select>
              </div>
              <div className='mainFormField'>
                <label className='mainFormLabel'>Candidate's Interest</label>
                <select
                  className='mainFormSelect'
                  name='interest'
                  onChange={e => handleChangeField('interest', e.target.value)}
                  id='interest'
                >
                  <option value=''>Please choose an option</option>
                  <option value='travel_position'>Travel Position</option>
                  <option value='interim_leadership'>Interim Leadership</option>
                  <option value='direct_hire'>Direct Hire</option>
                </select>
              </div>
            </div>
            <span className='referralFormSubtitle'>About You</span>
            <div className='mainFormFields'>
              <div className='mainFormField'>
                <label className='mainFormLabel'>
                  First Name <span className='mainFormRequiredMark'>*</span>
                </label>
                <input
                  className='mainFormInput'
                  value={data.user_first_name}
                  id='user_first_name'
                  onChange={e => handleChangeField('user_first_name', e.target.value)}
                />
              </div>
              <div className='mainFormField'>
                <label className='mainFormLabel'>
                  Last Name <span className='mainFormRequiredMark'>*</span>
                </label>
                <input
                  className='mainFormInput'
                  value={data.user_last_name}
                  id='user_last_name'
                  onChange={e => handleChangeField('user_last_name', e.target.value)}
                />
              </div>
              <div className='mainFormField'>
                <label className='mainFormLabel'>
                  Phone Number{isCheckboxActive && <span className='mainFormRequiredMark'> *</span>}
                </label>
                <input
                  className='mainFormInput'
                  value={data.user_phone_number}
                  id='user_phone_number'
                  onChange={e => handleChangeField('user_phone_number', e.target.value)}
                />
              </div>
              <div className='mainFormField'>
                <label className='mainFormLabel'>
                  Email Address <span className='mainFormRequiredMark'>*</span>
                </label>
                <input
                  className='mainFormInput'
                  value={data.user_email_address}
                  id='user_email_address'
                  onChange={e => handleChangeField('user_email_address', e.target.value)}
                />
              </div>
              <div className='mainFormTextarea'>
                <label className='mainFormLabel'>Additional Notes</label>
                <textarea
                  className='mainFormComment'
                  value={data.notes}
                  row={3}
                  id='notes'
                  onChange={e => handleChangeField('notes', e.target.value)}
                ></textarea>
              </div>
            </div>
            <div
              className={cn(
                'mainFormAgreeCheck',
                !isCheckboxActive &&
                  (data.candidate_phone_number?.trim() || data.user_phone_number?.trim()) &&
                  'mainFormAgreeCheckError',
              )}
            >
              <label>
                <input
                  type='checkbox'
                  checked={isCheckboxActive}
                  onChange={e => setCheckboxActive(e.target.checked)}
                />
                <span>
                  By checking this box and providing my phone number, I agree to receive SMS/text messages from American
                  Consultants regarding job opportunities, interview scheduling, application updates, onboarding information, and
                  service-related notifications. Message frequency varies (up to 10 msgs/month). Msg & data rates may apply. Reply
                  STOP to opt out or HELP for help. Mobile information and consent to receive SMS will not be shared with third
                  parties or affiliates for marketing or promotional purposes. See our{' '}
                  <a
                    href='https://app.termly.io/policy-viewer/policy.html?policyUUID=d94582df-8db3-4369-9a8a-e1e1f088c58d'
                    target='_blank'
                  >
                    Privacy Policy
                  </a>{' '}
                  and{' '}
                  <a
                    href='https://app.termly.io/policy-viewer/policy.html?policyUUID=c39976da-bc93-427b-a511-25e33d082944'
                    target='_blank'
                  >
                    Terms & Conditions
                  </a>{' '}
                  for details.
                </span>
              </label>
            </div>
            <div
              className={cn(
                'mainFormButton',
                (!data.candidate_first_name?.trim() ||
                  !data.candidate_last_name?.trim() ||
                  !data.candidate_email_address?.trim() ||
                  !data.user_first_name?.trim() ||
                  !data.user_last_name?.trim() ||
                  !data.user_email_address?.trim() ||
                  (isCheckboxActive && !data.user_phone_number?.trim()) ||
                  (!isCheckboxActive && (data.candidate_phone_number?.trim() || data.user_phone_number?.trim())) ||
                  !isValidPhone(data.candidate_phone_number) ||
                  !isValidPhone(data.user_phone_number) ||
                  !isValidEmail(data.user_email_address) ||
                  !isValidEmail(data.candidate_email_address) ||
                  isSending) &&
                  'mainFormButtonDisabled',
              )}
              onClick={e => handleSubmit(e)}
            >
              Submit Referral
            </div>
          </div>
        </div>
      </div>

      {!!isPopupOpen && <Popup onClose={() => setIsPopupOpen(false)} />}

      <PreFooter
        mainButtonText='Schedule Consultation'
        onMainClick={() => setIsPopupOpen(true)}
        title='Ready to Assess Your Revenue Cycle?'
        text='Schedule your comprehensive revenue cycle assessment consultation today.'
      />
      <Footer />
    </div>
  );
};

export default MainPage;
